import { lazy, StrictMode, Suspense, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/dm-sans";
import "@fontsource/dm-mono/400.css";
import { GardenPage, GardenDocs } from "./garden/GardenPage";

const WorkspaceApp = lazy(() => import("./WorkspaceApp"));

function Root() {
  const [url, setUrl] = useState(() => new URL(location.href));
  useEffect(() => {
    const navigate = () => setUrl(new URL(location.href));
    window.addEventListener("popstate", navigate);
    window.addEventListener("hashchange", navigate);
    return () => {
      window.removeEventListener("popstate", navigate);
      window.removeEventListener("hashchange", navigate);
    };
  }, []);
  const legacyNotebook =
    new URLSearchParams(url.hash.slice(1)).has("page") ||
    url.searchParams.has("lab") ||
    url.searchParams.has("__verification");
  if (url.pathname === "/docs/mcp" || url.pathname === "/docs/mcp/")
    return <GardenDocs mcp />;
  if (url.pathname === "/docs" || url.pathname === "/docs/")
    return <GardenDocs />;
  if (url.pathname === "/" && !legacyNotebook) return <GardenPage />;
  return (
    <Suspense
      fallback={
        <div className="garden-loading" role="status">
          Opening your notebook…
        </div>
      }
    >
      <WorkspaceApp />
    </Suspense>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("Missing application root");
createRoot(root).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
